import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Company } from 'src/app/core/models/company';
import { BaseComponent } from '@stockaid/core';
import { AdHistoryLogAutomationStats } from 'src/app/core/models/ad-history-log';
import { Router } from '@angular/router';

export type RiskType = 'high-risk' | 'moderate-risk' | 'low-risk' | 'neutral';


@Component({
  selector: 'app-alert-product-ads-history-logs',
  templateUrl: './alert-product-ads-history-logs.component.html',
  styleUrls: ['./alert-product-ads-history-logs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AlertProductAdsHistoryLogsComponent extends BaseComponent implements OnInit {
  @Input() automationStats: AdHistoryLogAutomationStats | null = null;
  @Output() openHistoryLogs = new EventEmitter<{ triggerType: string }> ();
  @Output() openAdsDetailLogs = new EventEmitter<{ action:string; ids:string[] }> ();
  isOpen = true;
  currentCompany: Company;
  isLoading = true;

  constructor(
    private router: Router,
  ) {
    super();
  }

  onClose(){
    this.isOpen = false;
  }

  onRestock() {
    this.router.navigate(['dashboard/shipments/restock-suggestions'], {queryParams: {vendorName: '[All Suppliers]', skus: 'lowstock_sku'}});
  }

  onAdsDetailLogs(action: 'ENABLE' | 'PAUSE') {
    if (!this.automationStats) return;
    const filters = {
      ids: action === 'ENABLE' ? this.automationStats.enabled.ids : this.automationStats.paused.ids,
      action: action === 'ENABLE' ? 'UNPAUSE' : 'PAUSE',
    };
  this.openAdsDetailLogs.emit(filters);
}

  onHistory() {
    const filters = {
      triggerType: 'AUTO',
      ids: this.automationStats?.enabled.ids.concat(this.automationStats?.paused.ids),
    };
    this.openHistoryLogs.emit(filters);
  }

  ngOnInit(): void {
    this.isOpen = true;
  }
}
